<div
  *transloco="let t; read: 'configurations.move-dialog'"
  class="xi-modal__container move-configuration-dialog__container"
>
  <h2 class="xi-modal__title move-configuration__title">{{ t('title') }}</h2>

  <div class="xi-modal__content move-configuration-dialog__content">
    <p>{{ t('content') }}</p>

    @for (group of visibleGroups; track group) {
      <xi-radio
        name="groupRadio"
        [checked]="group.group_id === selectedGroup.group_id"
        [value]="group"
        [label]="group.group_name | titlecase"
        (onChange)="onChangeGroup(group)"
      ></xi-radio>
    }
  </div>

  <div class="xi-modal__actions move-configuration-dialog__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="cancel()"></xi-default-button>

    <xi-default-button
      [text]="t('confirm')"
      [disabled]="originalGroup.group_id === selectedGroup.group_id"
      (onClick)="move()"
    ></xi-default-button>
  </div>
</div>
